import { render, staticRenderFns } from "./PlayButton.vue?vue&type=template&id=25b3e70e&scoped=true&"
import script from "./PlayButton.vue?vue&type=script&lang=ts&"
export * from "./PlayButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlayButton.vue?vue&type=style&index=0&id=25b3e70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b3e70e",
  null
  
)

export default component.exports